import { parseDate } from '@internationalized/date';

import type { DateValue } from 'react-aria-components';

export type TAutoPaySelection = 'unset' | 'true' | 'false';

export const autoPayOptions: Array<{ id: TAutoPaySelection; label: string }> = [
  { id: 'unset', label: 'Not set' },
  { id: 'true', label: 'Yes' },
  { id: 'false', label: 'No' },
];

export const getDatePickerValue = (dateString: string): DateValue | null => {
  if (dateString.trim().length === 0) {
    return null;
  }

  try {
    return parseDate(dateString);
  } catch {
    return null;
  }
};
